import {CurrentWeatherWidget} from "./widgets/current-weather";

export const widgets = {
  "weather:current-weather": CurrentWeatherWidget,
};
